import { KdsTicket } from '../types/ticket';

export const sortTicketByPrepareAt = (tickets: KdsTicket[]): KdsTicket[] =>
    tickets.sort(({ prepareAt: date1 }, { prepareAt: date2 }) => (date1 < date2 ? -1 : 1));

export const sortTicketByPrepareAtDesc = (tickets: KdsTicket[]): KdsTicket[] =>
    tickets.sort(({ prepareAt: date1 }, { prepareAt: date2 }) => (date1 < date2 ? 1 : -1));
